export const PlantItemRenewalEditItemPage = {
  itemLocationLabel: 'Location of item',
  itemRegistrationNumberLabel: 'Registration number',
  itemIdentifiersLabel: 'Item identifiers',
  itemIdentifiersDesc: 'Enter or change details that help you identify your plant item.',
  specificLocationLabel: 'Specific location of the item',
  uniqueIdentifierLabel: 'Unique identifier for the item',
  uniqueIdentifierDesc: 'This description is for your records only.',
  relocationNotificationFormUrl:
    'https://www.service.nsw.gov.au/transaction/notify-relocation-or-change-ownership-registered-plant',
};
